import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminProfileData } from "../api/userAPI";

interface UserState {
  profile: AdminProfileData | null;
  isLoading: boolean;
}

const initialState: UserState = {
  profile: null,
  isLoading: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<AdminProfileData>) => {
      state.profile = action.payload;
    },
    clearProfile: (state) => {
      state.profile = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setProfile, clearProfile, setLoading } = userSlice.actions;
export default userSlice.reducer;

